import React from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardList, CalendarDays, FileText, Wrench, Sparkles, ShoppingCart, ArrowRight } from "lucide-react";
import SmartHeader from "../../components/smart/SmartHeader";
import CustomerTabBar from "../../components/CustomerTabBar";
import { useCart } from "../../context/CartContext";

const ITEMS = [
  { id: "orders", t: "Ordini", d: "Consegne in corso e storico ordini", icon: ClipboardList, to: "/app/orders", c: "#00E676" },
  { id: "prenotazioni", t: "Prenotazioni", d: "Tavoli e prenotazioni nei locali", icon: CalendarDays, to: "/app/prenotazioni", c: "#7DF9FF" },
  { id: "bookings", t: "Servizi prenotati", d: "Appuntamenti con i professionisti", icon: Wrench, to: "/app/bookings", c: "#FF9F45" },
  { id: "quotes", t: "Preventivi", d: "Richieste e preventivi ricevuti", icon: FileText, to: "/app/quotes", c: "#FFD700" },
  { id: "esperienze", t: "Esperienze", d: "Le esperienze che hai acquistato", icon: Sparkles, to: "/app/esperienze", c: "#FF7AC6" },
];

export default function MyActivity() {
  const navigate = useNavigate();
  const { count } = useCart();

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white pb-24 animate-in fade-in duration-300" data-testid="myactivity-page">
      <SmartHeader current="attivita" />
      <main className="max-w-4xl mx-auto px-3 sm:px-6 py-6">
        <h1 className="font-['Unbounded'] font-bold text-3xl md:text-4xl tracking-tight leading-none">
          Le tue <span className="text-[#00E676]">attività</span>
        </h1>
        <p className="text-white/50 text-sm mt-2 mb-6">Ordini, prenotazioni, servizi ed esperienze: tutto lo stato delle tue operazioni.</p>

        {count > 0 && (
          <button
            data-testid="myactivity-cart"
            onClick={() => navigate("/app/checkout")}
            className="w-full mb-5 rounded-2xl p-4 border border-[#00E676]/40 bg-gradient-to-r from-[#00E676]/15 to-[#131316] flex items-center justify-between active:scale-[0.99] transition-transform"
          >
            <span className="flex items-center gap-3 font-semibold"><ShoppingCart className="h-5 w-5 text-[#00E676]" /> Carrello · {count} articoli</span>
            <span className="text-[#00E676] text-sm font-semibold">Vai al checkout →</span>
          </button>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
          {ITEMS.map((it) => (
            <button
              key={it.id}
              data-testid={`myactivity-${it.id}`}
              onClick={() => navigate(it.to)}
              className="rounded-2xl bg-[#131316] border border-white/10 hover:border-[#00E676]/40 p-4 flex items-center gap-4 text-left transition-colors group active:scale-[0.99]"
            >
              <div className="w-12 h-12 rounded-2xl bg-white/5 flex items-center justify-center shrink-0" style={{ color: it.c }}>
                <it.icon className="h-6 w-6" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-['Unbounded'] font-bold text-sm text-white">{it.t}</h3>
                <p className="text-xs text-white/50 mt-0.5 leading-snug">{it.d}</p>
              </div>
              <ArrowRight className="h-4 w-4 text-white/30 group-hover:text-[#00E676] transition-colors" />
            </button>
          ))}
        </div>
      </main>
      <CustomerTabBar active="attivita" />
    </div>
  );
}
